import * as IoC from 'inversify';
import { registerCommand } from '@/app/tracking/api';
import * as Api from '../api'
import { XApiCompleteCourseCommandHandler } from './xapi-complete-course-command-handler';

export const courseTinCanTrackingModule = new IoC.ContainerModule((bind) => {
  registerCommand(Api.CompleteCourseCommandName, XApiCompleteCourseCommandHandler, bind);
})
